module.exports = __webpack_public_path__ + "static/CoconutsInc-scrn-1733ef3605b1ee3e9cdbd0f008b01f8b.png";